
export class AddUser {
    public id: any;
    public employeeId: any;
    public network_id: string;
    public email_address: string;
    public first_name: string;
    public middle_name: string;
    public last_name: string;
    public userRole: string;
    public user_type: string;
    public sales_rep_channel: string;
    public sales_rep_channel_desc: string;
    public sales_rep_type: string;
    public sales_rep_id: string;
    public joining_date: Date;
    public work_status: string;
    public termination_date: Date;
    public operator_id: string;
    public soft_termination_date: Date;
    public vacation_start_date: Date;
    public vacation_end_date: Date;
    public effective_date: any;
    public comm_plan_id: number;
    public commplan_id: string;
    public commission_plan: string;
    public comPlan: string;
    public commissionable: string;
    public supervisor_id: any;
    public calendar_type: string;
    public assc_corps: string;
    public current_rec_flag: string;
    public created_dt: Date;
    public created_by: string;
    public updated_dt: Date;
    public updated_by: string;
    public supervisor_name: string;
    public supervisor_pref_name: string;
    public pref_first_name: string;
    public pref_last_name: string;
    public std_hours: number;
    public corps: any;
    public corp: any;
    public payroll_start_date: any;
    public payroll_end_date: any;
    public edit: boolean;
    public changeColor: boolean[]
    public profileStatus: string;
    public userDoc: string;
    public commPlanId: any;
    public selected: boolean;
    public language: string;
    public activeCommPeriod: string;
    public name: string;
    public supName: string;
    public comPlanTwo: string;
    public comPlanThree: string;
    public curDate: any;
    public prevDateOne: any;
    public prevDateTwo: any;
    public edate: any;
    public softdate: Date;
    public checkboxchecked: any;
    public supname: string;
    public sales_channel_desc: string;
    public supname1: string;
    public supname2: string;
    public supname3: string;
    public active_flag: string;
    public getasofdate: string;
    public pageStatus: string;
    public rowid: number;
    public user_role: string;
    public stat: string;
    public unlock:string;

    constructor() {
        this.stat = null;
        this.user_role = null;
        this.rowid = null;
        this.pageStatus = null;
        this.getasofdate = null;
        this.active_flag = null;
        this.supname1 = null;
        this.supname2 = null;
        this.supname3 = null;
        this.sales_channel_desc = null;
        this.id = null;
        this.employeeId = null;
        this.network_id = null;
        this.email_address = null;
        this.first_name = null;
        this.middle_name = null;
        this.last_name = null;
        this.userRole = null;
        this.user_type = null;
        this.sales_rep_channel = null;
        this.sales_rep_type = null;
        this.sales_rep_id = null;
        this.joining_date = null;
        this.work_status = null;
        this.termination_date = null;
        this.operator_id = null;
        this.soft_termination_date = null;
        this.vacation_start_date = null;
        this.vacation_end_date = null;
        this.effective_date = null;
        this.comm_plan_id = null;
        this.commission_plan = null;
        this.commissionable = 'Y';
        this.supervisor_id = null;
        this.calendar_type = null;
        this.assc_corps = null;
        this.current_rec_flag = null;
        this.created_dt = null;
        this.created_by = null;
        this.updated_dt = null;
        this.updated_by = null;
        this.supervisor_name = null;
        this.supervisor_pref_name = null;
        this.pref_first_name = null;
        this.pref_last_name = null;
        this.corps = [];
        this.corp = null;
        this.payroll_start_date = null;
        this.payroll_end_date = null;
        this.edit = false;
        this.changeColor = [];
        this.profileStatus = null;
        this.userDoc = null;
        this.std_hours = null;
        this.sales_rep_channel_desc = null;
        this.commPlanId = null;
        this.selected = false;
        this.language = null;
        this.activeCommPeriod = null;
        this.name = null;
        this.supName = "";
        this.comPlanTwo = "";
        this.comPlanThree = "";
        this.curDate = null;
        this.prevDateOne = null;
        this.prevDateTwo = null;
        this.edate = null;
        this.softdate = null;
        this.checkboxchecked = null;
        this.supname = null;
        this.commplan_id = null;
        this.unlock = null;
    }
}
